import { isValidGUID } from './attribution';

/**
 * Condition for enable shortform's functionality.
 * Checks the donor in GET params.
 *
 * @param query
 *  GET params from router.
 * @return boolean
 *  True or false.
 */
// TODO: Revise and add 'isValidGUID(query.source)' checker if needed,
//  as part of https://www.pivotaltracker.com/story/show/188587772,
//  also, see cnet/components/03_organisms/DonationForm/index.js.
export const hasShortformValuesInQuery = (query) =>
  query?.dsn && isValidGUID(query.dsn) && query.source;
